module.exports = __webpack_public_path__ + "static/media/Riser_On.d4be7801.png";